import { all } from 'redux-saga/effects';
import Auth from './Auth';
import Waan from './Waan';

export default function* rootSaga() {
  yield all([Auth(), Waan()]);
}
